import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_generation, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { useTranslation } from 'react-i18next';
import { WSSharedTableHeader } from '../_base/WSSharedTableHeader';
import { WSSharedTableRow } from '../_base/WSSharedTableRow';

export function WSSharedUserTasksTable() {
  const { user_tasks_map } = use_slice_generation(['user_tasks_map']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * RENDERS
   */
  function render_rows(user_tasks: DTO__user_task[]) {
    return user_tasks.map((user_task, index) => {
      return (
        <WSSharedTableRow
          item={user_task}
          key={`${user_task._id}_${index}`}
          url={ENUM__page_type.BUILD_PATH_USER_TASK(user_task.getMostRecentGeneration()._id)}
        />
      );
    });
  }

  function render_table(user_tasks: DTO__user_task[]) {
    user_tasks = user_tasks
      .filter(user_task => user_task.workspace_id == workspace_current._id)
      .filter(user_task => user_task.is_shared)
      .sort(DTO__workspace_child_enity.sort_by_sharing_started_at);

    let out = <></>;

    if (user_tasks.is_empty()) {
      out = <TABLE__empty />;
    } else {
      out = <div className="flex flex-col justify-start items-center h-full w-full overflow-auto">{render_rows(user_tasks)}</div>;
    }

    return out;
  }

  /*
   * HTML
   */
  return (
    <div className="w-full h-full">
      <div
        className={`${md(
          'h-full w-full overflow-auto',
          ' pt-2 max-h-[25vh]',
        )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
      >
        <div className="text-xl">{t(i18n_page_settings_workspace.tabs.shared_entities.user_tasks_component.title)}</div>
        <WSSharedTableHeader />

        {render_table(Array.from(user_tasks_map.values()))}
      </div>
    </div>
  );
}
